import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'components/snackbar';
import { Box, Button, Card, CardContent, FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material'


/**
 * ForgotPassword renders a dialog to select a method for resetting the password.
 * It calls the `onChange` function with the selected method and navigates to the
 * relevant page.
 * @param {function} onChange - function to call with the selected method
 * @param {boolean} isMobile - indicates whether the dialog is for mobile or not
 * @returns {JSX.Element}
 */
const ForgotPassword = ({ onChange, isMobile }) => {
    const navigate = useNavigate();
    const [check, setCheck] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    /**
     * Handles the submission of the form, based on the selected method.
     * If a method is selected, it navigates to the relevant page and calls the onChange function.
     * If no method is selected, it displays an error message.
     */
    const onSubmit = () => {
        if (check === 'OTP') {
            navigate('/forgot-password', { state: { method: 'otp' } })
            // onChange(true);
        } else if (check === 'RESET') {
            navigate('/forgot-password', { state: { method: 'link' } })
            // onChange(true);
        } else {
            enqueueSnackbar("Please select atleast one option", { variant: 'error' })
        }
    }

    return (
        <Card variant="outlined">
            <CardContent>

                <Box mb={3}>
                    <Typography className="title">Forgot Password?</Typography>
                    <Typography className="info-text">Don't worry! You can log in using either of the two options below</Typography>
                </Box>

                <Box sx={{ padding: "0 10px" }}>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue=""
                            name="radio-buttons-group"
                        >
                            <FormControlLabel
                                value="OTP"
                                control={<Radio />}
                                label={<Box>
                                    <Typography className="option-title">One time login with OTP</Typography>
                                    <Typography className="option-text">OTP will be sent to your registered WhatsApp number and Email address</Typography>
                                </Box>}
                                sx={{ marginBottom: "1rem" }}
                                onChange={(e) => setCheck(e.target.value)}
                            />
                            <FormControlLabel
                                value="RESET"
                                control={<Radio />}
                                label={<Box>
                                    <Typography className="option-title">Reset Password</Typography>
                                    <Typography className="option-text">Password reset link will be shared on your registered WhatsApp number and Email address</Typography>
                                </Box>}
                                onChange={(e) => setCheck(e.target.value)}
                            />
                        </RadioGroup>
                    </FormControl>
                </Box>

                <Box mt={3}>
                    {isMobile ?
                        <Stack direction={{ xs: 'column', sm: 'row' }} flexDirection={{ xs: 'column-reverse', gap: '16px' }} justifyContent={'center'} alignItems={'center'} spacing={{ xs: '15px', md: '20px' }}>
                            <Button fullWidth className="cancel-btn" variant="outlined" size="medium" onClick={onChange}>Cancel</Button>
                            <Button fullWidth className="continue-btn" onClick={onSubmit} variant="contained" size="medium">Continue</Button>
                        </Stack> :
                        <Stack direction="row" justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <Button fullWidth className="cancel-btn" variant="outlined" size="medium" onClick={onChange}>Cancel</Button>
                            <Button fullWidth className="continue-btn" onClick={onSubmit} variant="contained" size="medium">Continue</Button>
                        </Stack>}
                </Box>
            </CardContent>
        </Card>
    )
}

export default ForgotPassword
